<template>
	<div>
		<div
			class="modal-top d-flex flex-column justify-content-center align-items-start align-self-stretch p-3"
			style="background-color: #f2f5f7"
		>
			<div class="d-flex align-items-center justify-content-between w-100">
				<div class="d-flex flex-column align-items-start">
					<p
						class="f-Overpass f-w-400 m-0 f-12 text-center align-items-start"
					>
						No Nota
					</p>
					<p
						class="f-Overpass f-w-600 m-0 f-14 text-center align-items-start"
					>
						{{ detailSnap.id }}
					</p>
				</div>

				<div class="d-flex flex-column align-items-end">
					<p
						class="f-Overpass f-w-400 m-0 f-12 text-center align-items-start"
					>
						Tanggal
					</p>
					<p
						class="f-Overpass f-w-600 m-0 f-14 text-center align-items-start"
					>
						{{ $moment(detailSnap.created_at).format("L") }}
					</p>
				</div>
			</div>
		</div>

		<div
			class="d-flex p-16 flex-column align-items-start align-self-stretch m-3"
			style="gap: 8px"
		>
			<p class="f-Overpass f-w-600 m-0 f-14 text-center align-items-start">
				{{ detailSnap.snap_transaksi_detail[0].snap_mesin.nama }}
			</p>
			<div class="d-grid align-items-start">
				<p class="f-Overpass f-w-400 f-12 m-0 f-c-grey">layanan</p>
				<p class="f-Overpass f-w-400 f-14 m-0 f-c-black">
					{{ detailSnap.snap_transaksi_detail[0].snap_layanan.nama }}
				</p>
			</div>
			<div class="d-flex align-items-center" style="gap: 4px">
				<img src="../../../assets/icons/time.svg" alt="time" />
				<p class="f-Overpass f-12 f-w-400 mt-1 my-0 f-c-grey">
					{{ displayDuration(detailSnap.snap_transaksi_detail?.[0].snap_layanan.durasi) }}
				</p>
			</div>
			<div class="d-flex align-items-center" style="gap: 4px">
				<img src="../../../assets/icons/location.svg" alt="time" />
				<p class="f-Overpass f-12 f-w-400 mt-1 my-0 f-c-grey">
					{{ detailSnap.outlet.nama }} - {{ detailSnap.outlet.kota }}
				</p>
			</div>
		</div>

		<div
			class="d-flex p-a-16 flex-column align-items-start"
			style="border-top: solid 2px #ededed"
		>
			<div class="d-flex align-items-start justify-content-between w-100">
				<p class="f-Overpass f-c-black f-14 f-w-400 m-0">Harga Layanan</p>
				<p class="f-Overpass f-14 f-w-400 m-0" :class="!detailSnap.isDelete ? 'f-c-red' : 'f-c-green'">
					{{ formatCurrency(detailSnap.grandtotal) }}
				</p>
			</div>
		</div>
	</div>
</template>
<script>
import { mapState } from 'vuex';

export default {
	name: 'transaksiContent',
	computed: {
    ...mapState("riwayat", {
      detailSnap: "detailSnap",
    }),
  },
}
</script>